import { getDietComment } from '@/service/h5-api'
let timeObj = null; // 倒计时对象
const state = {
  IdentipyShow: false, //设置AI点评浮窗是否显示
  loading: false, //设置AI点评加载状态
  AIText: '你的饮食中蛋白质摄入充足，但热量和蔬菜量偏低。', //AI点评内容
  curMessage: null, //当前消息内容
  generaterId: null, //当前消息时间戳,每次生成都有独立id
  timeLimit: 30, //AI点评生成结束时间
  time: 0, //AI点评生成倒计时
  recordIndentipy: {}, // ai分析结果
};

const store = {
  namespaced: true,
  state,
  mutations: {
    SET_AIDENTIPY_SHOW(state, data) {
      state.IdentipyShow = data
    },
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_CURMESSAGE(state, data) {
      state.curMessage = data
    },
    SET_AITEXT(state, data) {
      state.AIText = data
    },
    // 记录时间戳，用于判断是否需要更新,有些终止生成操作需要不关心回调结果
    SET_GENERATERID(state, data) {
      state.generaterId = data
    },
    SET_TIME(state, data) {
      state.time = data
    },
    SET_RECORDINDENTIPY(state, data) {
      state.recordIndentipy = data
    }
  },
  actions: {
    setAIdentipyShow(state, data) {
      // 初始化loading态
      state.commit('SET_GENERATERID', null)
      state.commit('SET_AIDENTIPY_SHOW', data)
    },
    // 当前消息内容
    setCurMessage(state, data) {
      state.commit('SET_CURMESSAGE', data)
      state.dispatch('toGenerateMessage')
    },
    // 存入ai分析结果
    recordIndentipy(state, data) {
      state.commit('SET_RECORDINDENTIPY', data)
    },
    // 生成AI点评内容
    toGenerateMessage(state, data) {
      const userId = state.state.curMessage?.from?.split('@')[1] || state.state.curMessage?.srcData?.baseUserInfo?.userId
      const imageUrl = state.state.curMessage?.payload?.imageInfoArray[0]?.imageUrl || state.state.curMessage?.payload?.imageInfoArray[0]?.url
      const msgId = state.state.curMessage?.id
      // 停止之前的倒计时
      clearInterval(timeObj)
      console.log('停止之前的倒计时')
      state.commit('SET_LOADING', true)
      state.commit('SET_RECORDINDENTIPY', {})
      state.commit('SET_TIME', state.state.timeLimit)
      // 倒计时
      timeObj = setInterval(() => {
        state.commit('SET_TIME', state.state.time - 1)
        if (state.state.time === 0) {
          state.dispatch('generateTimeout')
        }
      }, 1000)
      if (userId && imageUrl) {
        state.dispatch('getAIText', { userId, imageUrl, msgId })
      }
    },
    // 获取AI点评
    getAIText(state, data) {
      // 记录时间戳，用于判断是否需要更新
      const timestamp = new Date().getTime()
      state.commit('SET_GENERATERID', timestamp)
      getDietComment(data).then(res => {
        console.log('==============检测到识别结果')
        if (state.state.generaterId !== timestamp) return
        clearInterval(timeObj)
        state.commit('SET_GENERATERID', null)
        if (res.code === '0' && res.data) {
          state.commit('SET_LOADING', false)
          state.commit('SET_AITEXT', res.data)
        } else {
          state.dispatch('generateTimeout')
        }
      }).catch(err => {
        console.log(err)
        state.dispatch('generateTimeout')
      })
    },
    // 生成超时
    generateTimeout(state, data) {
      state.dispatch('stopGenerate')
      state.commit('SET_GENERATERID', -1)
      uni.showToast({
        title: '真不好意思，这次没能成功识别，您稍后再试试~',
        icon: 'none',
        duration: 2000
      })
    },
    // 终止点评生成
    stopGenerate(state, data) {
      clearInterval(timeObj)
      state.commit('SET_GENERATERID', null)
      state.commit('SET_TIME', 0)
      state.dispatch('setAIdentipyShow', false)
    }
  },
}
export default store;